import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "gradient", "expandButton"]
  static values = {
    maxHeight: { type: Number, default: 500 },
    expanded: { type: Boolean, default: false }
  }

  connect() {
    this.checkContentHeight()
  }

  checkContentHeight() {
    const contentHeight = this.contentTarget.scrollHeight

    if (contentHeight > this.maxHeightValue) {
      this.element.classList.add("expandable-active")
      this.contentTarget.style.maxHeight = `${this.maxHeightValue}px`
      this.contentTarget.classList.add("overflow-hidden")
      this.gradientTarget.classList.remove("hidden")
      this.expandButtonTarget.classList.remove("hidden")
    } else {
      this.element.classList.remove("expandable-active")
      this.gradientTarget.classList.add("hidden")
      this.expandButtonTarget.classList.add("hidden")
    }
  }

  expand() {
    this.expandedValue = true
    this.contentTarget.style.maxHeight = "none"
    this.contentTarget.classList.remove("overflow-hidden")
    this.gradientTarget.classList.add("hidden")
    this.expandButtonTarget.classList.add("hidden")

    // Add smooth transition
    this.contentTarget.style.transition = "max-height 0.3s ease-out"
  }
}